var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",staticStyle:{"display":"flex","flex-direction":"column"}},[_c('ThemePicker',{staticStyle:{"display":"none"}}),_c('Header'),_c('div',{staticClass:"home_content"},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }